module.exports = __webpack_public_path__ + "static/google-play-a1237ce72322bf66bf58f462a5dd4795.png";